import { useEffect, useState } from "react";
  import { useRef } from "react";
const API_URL = process.env.REACT_APP_API_URL;

const PackageMenuManager = () => {
  const [packages, setPackages] = useState([]);
  const [selectedPackage, setSelectedPackage] = useState("");

  const [allItems, setAllItems] = useState([]);
  const [packageItems, setPackageItems] = useState([]); // current menu
  const [selectedToAdd, setSelectedToAdd] = useState([]);

  const [showDropdown, setShowDropdown] = useState(false);
  const [loading, setLoading] = useState(false);
const [search, setSearch] = useState("");
  /* ================= FETCH ================= */

  const fetchPackages = async () => {
    const res = await fetch(`${API_URL  }/api/packages`);
    const data = await res.json();
    setPackages(data);
  };

 const fetchItems = async () => {
  const res = await fetch(`${API_URL}/api/items`);
  const data = await res.json();

  const normalized = (data || []).map(i => ({
    ID: Number(i.ID),   // 🔥 FIX HERE
    I_Name: i.I_Name,
    Website_Rate: i.Website_Rate
  }));

  setAllItems(normalized);
};

 const fetchPackageMenu = async (packageId) => {
  const res = await fetch(`${API_URL}/api/package-menu/${packageId}`);
  const data = await res.json();

  const normalized = (data || []).map(i => ({
    ...i,
    ID: Number(i.ID) // 🔥 important
  }));

  setPackageItems(normalized);
};

  useEffect(() => {
    fetchPackages();
    fetchItems();
    console.log("ALL ITEMS:", allItems);
console.log("PACKAGE ITEMS:", packageItems);
  }, []);

  /* ================= HANDLERS ================= */

  const handlePackageChange = async (id) => {
    setSelectedPackage(id);
    if (id) await fetchPackageMenu(id);
    else setPackageItems([]);
  };

  const toggleAddItem = (id) => {
    setSelectedToAdd(prev =>
      prev.includes(id)
        ? prev.filter(i => i !== id)
        : [...prev, id]
    );
  };

  /* ================= BULK ADD ================= */

  const handleBulkAdd = async () => {
    if (!selectedPackage) return alert("Select package first");

    const existingIds = packageItems.map(i => i.ID);

    // merge (avoid duplicates)
    const updatedItems = [
      ...new Set([...existingIds, ...selectedToAdd])
    ];

    setLoading(true);

    await fetch(`${API_URL}/api/package-menu/${selectedPackage}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: updatedItems }),
    });

    await fetchPackageMenu(selectedPackage);

    setLoading(false);
    setShowDropdown(false);
  };

  /* ================= REMOVE ITEM ================= */

  const handleRemoveItem = async (id) => {
    const updated = packageItems
      .filter(i => i.ID !== id)
      .map(i => i.ID);

    await fetch(`${API_URL}/api/package-menu/${selectedPackage}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: updated }),
    });

    fetchPackageMenu(selectedPackage);
  };

  /* ================= FILTER (hide already added) ================= */

  const availableItems = allItems.filter(
  i =>
    !packageItems.some(p => Number(p.ID) === Number(i.ID)) &&
    (i.I_Name || "")
      .toLowerCase()
      .includes(search.toLowerCase())
);

  /* ================= UI ================= */



const dropdownRef = useRef();

useEffect(() => {
  const handleClickOutside = (e) => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
      setShowDropdown(false);
    }
  };

  document.addEventListener("mousedown", handleClickOutside);
  return () => document.removeEventListener("mousedown", handleClickOutside);
}, []);

  return (
    <div className="bg-white rounded-xl shadow-sm border p-5">
      <h2 className="text-xl font-bold mb-4 text-center border-b pb-2">
        Package Menu Manager
      </h2>

      {/* PACKAGE SELECT */}
      <select
        value={selectedPackage}
        onChange={(e) => handlePackageChange(e.target.value)}
        className="border px-3 py-2 rounded-md w-full mb-4"
      >
        <option value="">Select Package</option>
        {packages.map(p => (
          <option key={p.Id} value={p.Id}>
            {p.PackageName}
          </option>
        ))}
      </select>

      {/* CURRENT MENU LIST */}
      {selectedPackage && (
        <>
          <h3 className="font-semibold mb-2">Current Menu</h3>

          <div className="border rounded-md p-3 mb-4 max-h-40 overflow-y-auto">
            {packageItems.length === 0 && (
              <p className="text-sm text-gray-400">No items added</p>
            )}

            {packageItems.map(item => (
              <div
                key={item.ID}
                className="flex justify-between items-center py-1 border-b text-sm"
              >
                <span>{item.I_Name}</span>

                <button
                  onClick={() => handleRemoveItem(item.ID)}
                  className="text-red-500 text-xs"
                >
                  Remove
                </button>
              </div>
            ))}
          </div>

          {/* ADD ITEMS DROPDOWN */}
          <div ref={dropdownRef} className="relative mb-3">
          <div className="relative mb-3">
  <div
    onClick={() => setShowDropdown(!showDropdown)}
    className="border px-3 py-2 rounded-md cursor-pointer bg-white"
  >
    Add Items
  </div>

  {showDropdown && (
    <div className="absolute z-10 w-full bg-white border rounded-md mt-1 shadow">

      {/* 🔍 SEARCH BAR */}
      <div className="sticky top-0 bg-white p-2 border-b">
        <input
          type="text"
          placeholder="Search items..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="w-full px-3 py-2 border rounded-md text-sm outline-none focus:ring-2 focus:ring-teal-500"
        />
      </div>

      {/* LIST */}
      <div className="max-h-60 overflow-y-auto">
        {availableItems.length === 0 && (
          <p className="p-3 text-gray-400 text-sm">
            No items found
          </p>
        )}

        {availableItems.map(item => (
          <label
            key={item.ID}
            className="flex items-center gap-2 px-3 py-2 hover:bg-gray-100 cursor-pointer"
          >
            <input
              type="checkbox"
              checked={selectedToAdd.includes(item.ID)}
              onChange={() => toggleAddItem(item.ID)}
            />
            <span className="text-sm">
              {item.I_Name || "Unnamed Item"}
            </span>
          </label>
        ))}
      </div>
    </div>
  )}
</div>
</div>
          {/* ADD BUTTON */}
          <button
            onClick={handleBulkAdd}
            disabled={loading}
            className="bg-teal-600 text-white px-4 py-2 rounded-md"
          >
            {loading ? "Updating..." : "Add Selected Items"}
          </button>
        </>
      )}
    </div>
  );
};

export default PackageMenuManager;